var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 25.2H3c-1.7 0-3-1.3-3-3v-4.6c0-.6.4-1 1-1s1 .4 1 1v4.1c0 .8.7 1.5 1.5 1.5H8c.6 0 1 .4 1 1s-.4 1-1 1zm15.8-2.9c0 1.7-1.3 3-3 3h-4.6c-.6 0-1-.4-1-1s.4-1 1-1h4.1c.8 0 1.5-.7 1.5-1.5v-4.5c0-.6.4-1 1-1s1 .4 1 1v5zM1.2 9.8c-.6 0-1-.4-1-1v-5c0-1.7 1.3-3 3-3h4.6c.6 0 1 .4 1 1s-.4 1-1 1H3.7c-.8 0-1.5.7-1.5 1.5v4.5c0 .5-.5 1-1 1zm20.6-1V4.3c0-.8-.7-1.5-1.5-1.5h-4.1c-.6 0-1-.4-1-1s.4-1 1-1h4.6c1.7 0 3 1.3 3 3v5c0 .6-.4 1-1 1-.5 0-1-.5-1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.2h2.4v2.4H4V4.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 6.5h2.4v2.4H6.3V6.5zm0 10.3h2.4v2.4H6.3v-2.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 4.2h2.4v2.4H8.7V4.2zM3.9 8.9h2.4v2.4H3.9V8.9zm4.8 0h2.4v2.4H8.7V8.9zm1.9 13H4.4c-.4 0-.8-.3-.8-.8v-6.2c0-.4.3-.8.8-.8h6.2c.4 0 .8.3.8.8v6.2c-.1.4-.4.8-.8.8zm-5.4-1.5h4.7v-4.7H5.2v4.7zm10.2-3.6h2.4v2.4h-2.4v-2.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7 21.9h-6.2c-.4 0-.8-.3-.8-.8v-6.2c0-.4.3-.8.8-.8h6.2c.4 0 .8.3.8.8v6.2c-.1.4-.4.8-.8.8zm-5.5-1.5h4.7v-4.7h-4.7v4.7zm1.2-13.9h2.4v2.4h-2.4V6.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7 11.6h-6.2c-.4 0-.8-.3-.8-.8V4.6c0-.4.3-.8.8-.8h6.2c.4 0 .8.3.8.8v6.2c-.1.4-.4.8-.8.8zm-5.5-1.5h4.7V5.4h-4.7v4.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrScan);
export default __webpack_public_path__ + "static/media/QRScan.6d6352eb.svg";
export { ForwardRef as ReactComponent };